export const APP_TYPE = {
  COMMAND: 1
}

export const APP_TYPE_FIELD = {
  [APP_TYPE.COMMAND]: 'useCommand'
}